import secondaryModel2 from "../assets/secondary-model-2.webp";
import secondaryModel3 from "../assets/secondary-model-3.webp";
import secondaryModel5 from "../assets/secondary-model-5.webp";
import secondaryModel6 from "../assets/secondary-model-6.webp";
import secondaryModel9 from "../assets/secondary-model-9.webp";

import mainModel1 from "../assets/main-model-1.webp";

export const mainModelData = [
  {
    id: 1,
    imgSrc: mainModel1,
  },
];

export const secondaryModelData = [
  {
    id: 1,
    imgSrc: secondaryModel3,
    position: "leftCenter",
    isBackSide: false,
    isHidden: false,
  },
  {
    id: 2,
    imgSrc: secondaryModel5,
    position: "rightTop",
    isBackSide: false,
    isHidden: false,
  },
  {
    id: 3,
    imgSrc: secondaryModel2,
    position: "rightBottom",
    isBackSide: false,
    isHidden: true,
  },
  {
    id: 4,
    imgSrc: secondaryModel3,
    position: "leftTop",
    isBackSide: true,
    isHidden: false,
  },
  {
    id: 5,
    imgSrc: secondaryModel9,
    position: "leftBottom",
    isBackSide: true,
    isHidden: false,
  },
  {
    id: 6,
    imgSrc: secondaryModel6,
    isBackSide: true,
    position: "rightCenter",
    isHidden: false,
  },
];
